import { useFormContext } from "react-hook-form";

import { SecretField } from "src/connections/config/shared/SecretField";
import {
  Environment,
  MongoDBConnectionAuthConfigField,
  MongoDBConnectionConfigInputs,
} from "src/connections/types";

type SecretProps = {
  secretConfigField: MongoDBConnectionAuthConfigField;
  secretName: string;
  helpText: string;
  isRequired?: boolean;
  isErrored: boolean;
  environment: Environment;
};

export const MongoDBSecretField: React.FC<SecretProps> = ({
  secretConfigField,
  secretName,
  helpText,
  isRequired,
  isErrored,
  environment,
}) => {
  const { watch, setValue, register } =
    useFormContext<MongoDBConnectionConfigInputs>();

  const secretKey = `${environment}Config.${secretConfigField}` as const;

  const secretRecord = watch(secretKey);

  const enableSecret = () => {
    setValue(secretKey, { ...secretRecord, secret: false, value: null });
  };

  return (
    <SecretField
      enableSecret={enableSecret}
      helpText={helpText}
      isErrored={isErrored}
      isRequired={isRequired}
      isSecret={Boolean(secretRecord.secret)}
      register={register}
      secretKey={`${secretKey}.value`}
      secretName={secretName}
    />
  );
};
